import { render, staticRenderFns } from "./AboutView.vue?vue&type=template&id=1e53ab91&"
var script = {}
import style0 from "./AboutView.vue?vue&type=style&index=0&id=1e53ab91&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports